module.exports = __webpack_public_path__ + "img/Maritech-File-Sharing.f9ff9a78.webp";